<template>
  <div>
    <div style="margin: 10px 20px; display: flex;">
      <el-input placeholder="搜索項目" v-model="searchText" suffix-icon="el-icon-search" clearable @change="getProject()">
      </el-input>
      <!-- <div style="margin-left: 10px;">
        <el-button type="primary" icon="el-icon-search" @click="GETcommodityList('0', inputText)" style="background-color: #3E4F7A; border: none;"></el-button>
      </div> -->
    </div>
    <div style="display: flex; height: calc(100vh - 300px);"> <!-- 新增高度計算 -->
      <!-- 左側菜單 -->
      <div class="conter" style="width: 100px; background-color: #F9F9F9; height: 100%; overflow-y: auto;">
        <!-- 新增高度和滾動 -->
        <div v-for="(item, index) in menuLists" :key="index"
          :class="index == selLeftMenuIndex ? 'LeftMenuSelected' : ''"
          style="display: flex; justify-content: center; line-height: 60px; color: #666; font-size: 16px;"
          @click="menuSwitch(index, item.id)">
          {{ item.name }}
        </div>
      </div>
      <div
        style="flex: 1; background-color: #fff; height: 100%; overflow-y: auto; display: flex; flex-direction: column;">
        <!-- 新增高度和滾動 -->
        <div v-if="menuLists.length > 0" style="padding: 10px 20px 0px 20px; font-size: 18px; font-weight: bold;">{{
          menuLists[selLeftMenuIndex].name }}</div>

        <div style="display: flex; padding: 0 20px; margin: 16px 0; align-items: center;">
          <div v-for="(item, index) in vipMembers" :key="index"
            style="margin-right: 12px; font-size: 14px; color: grey;"
            @click="selVipIndex = index; level = item.level; getProject()"
            :class="index == selVipIndex ? 'vipSelected' : ''">
            {{ item.name }}
          </div>
        </div>

        <div v-if="commodityLists.length > 0">
          <div v-for="(item, index) in commodityLists" :key="index"
            style="margin-bottom: 4px; padding-right: 20px; position: relative;" @click="viewProject(item)">
            <div style="display: flex; align-items: center;">
              <div
                style="width: 50px; height: 50px; padding: 20px; display: flex; justify-content: center; align-items: center;">
                <img :src="`/api/file/download/${item.icon}`" alt="" style="width: 50px;border-radius: 10px;">
              </div>
              <div style="width: 70%;">
                <div
                  style="font-size: 18px; font-weight: 800; color: #3E4F7A; display: flex; justify-content: space-between; align-items: center; width: 100%;">
                  <div
                    style="background-color: #3E4F7A; color: white; font-weight: 400; font-size: 12px; padding: 2px 4px; border-radius: 4px;">
                    {{ item.shape }}
                  </div>
                  <div
                    style="margin-left: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-shrink: 1; min-width: 0; flex: 1;">
                    <!-- 添加 min-width: 0 -->
                    {{ item.name }}
                  </div>

                  <div style="display: flex; align-items: center;">
                    <div style="font-size: 14px;">🔥</div>
                    <span style="font-size: 16px; font-weight: 800; color: #C43826; margin-left: 6px;">{{ item.star
                    }}</span>
                  </div>
                </div>
                <div style="font-size: 16px; color: grey; margin-top: 6px;">{{ item.desc || "這個商品還沒有簡介~" }}
                </div>
              </div>
            </div>
            <!-- {{ vip }} -->
            <div v-if="vip < item.level"
              style="background-color: rgba(0, 0, 0, 0.5); width: 100%; height: 90px; position: absolute; top: 0px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
              <img src="../assets/suo.png" style="width: 20px; height: 20px;">
              <div style="color: #eeeeee; font-size: 14px; font-weight: 800;">該軟件需要達到{{ vipMembers[item.level + 1].name
                }}才可以解鎖</div>
            </div>
          </div>
        </div>

        <div v-if="commodityLists.length <= 0"
          style="flex: 1; display: flex; justify-content: center; align-items: center;">
          <el-empty description="當前類型暫無數據"></el-empty>
        </div>
      </div>
    </div>


    <!-- <el-drawer :title="commodityItemProject.name" :visible.sync="viewProjectShow" direction="btt" size="90%"
      class="project-drawer">
      

    </el-drawer> -->

    <div style="padding: 10px; border-top: 1px solid #eee; 
              background: #fafafa; text-align: center;">
      <div style="color: #999; font-size: 12px; line-height: 1.8;">
        <div>Copyright © 2018-2025 碼雲 版權所有</div>
        <div style="margin-top: 4px;">
          <span>技術驅動商業進化</span>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  name: 'ShopPage',
  props: {
    msg: String
  },
  data() {
    return {
      selLeftMenuIndex: 0,
      selVipIndex: 0,
      menuLists: [],
      commodityLists: [],
      searchText: '',
      rateTotals: [2, 5, 3],
      member: {
        value: ''
      },
      indexMenuId: "",
      class: '',
      vipMembers: [],
      level: "",
      userDataInfo: {},
      vip: -1
    }
  },

  mounted() {
    // 獲取分類
    this.getClass()

    // 獲取商品列錶
    this.getProject()

    // 獲取會員列表
    this.getVipMember()

    // 刷新用戶信息
    this.refreshUser()
  },

  methods: {
    refreshUser() {
      this.$axios.get("/api/user/info").then(res => {
        this.userDataInfo = res.data.data
        localStorage.setItem("userInfo", JSON.stringify(res.data.data))

        // 獲取會員
        this.getVipData()
      })
    },
    getVipData() {
      this.$axios.get("/api/vip_member/arr").then(r => {
        var d = r.data.data
        var res = d.res
        var amount = this.userDataInfo.accumulate

        // 檢測現在的會員
        for (var i = 0; i < res.length; i++) {

          if (amount >= res[i]) {
            this.vip = i
          } else {
            break
          }
        }
      })
    },
    getVipMember() {
      this.$axios.get(`/api/vip_member/list`).then(res => {
        var arr = []
        var d = res.data.data

        arr.push({
          name: "所有",
          level: ""
        })

        for (var i = 0; i < d.length; i++) {
          arr.push(d[i])
        }

        this.vipMembers = arr
      })
    },
    getProject() {
      this.$axios.get(`/api/project/list?class=${this.class}&search=${this.searchText}&level=${this.level}`).then(res => {
        this.commodityLists = res.data.data.items
      })
    },
    getClass() {
      this.$axios.get("/api/class/list").then(res => {
        var d = res.data.data.items
        var arr = []

        arr.push({
          "id": "",
          "name": "全部",
          "priority": 999999,
          "create_at": 0,
          "update_at": 0
        })

        for (var i = 0; i < d.length; i++) {
          arr.push(d[i])
        }

        this.menuLists = arr
      })
    },
    getMemberList() {
      console.log('獲取商品評價分列錶')
    },

    jinggao(e) {
      console.log('驗證用戶有沒有登錄，或者 購買等級夠不夠的鎖')
      if (localStorage.getItem("LOGINED")) {
        this.$message({
          message: `暫時無法購買當前軟件，請將會員等級提升到${e}`,
          type: 'warning'
        });
      } else {
        this.$message({
          message: `請登陸後在查閱商品詳情`,
          type: 'warning'
        });
      }
    },

    menuSwitch(index, menuId) {
      this.selLeftMenuIndex = index
      this.class = menuId
      this.getProject()
    },

    viewProject(item) {

      if (this.vip < item.level) {
        this.$message({
          message: `您的等級尚未達到項目解鎖要求。`,
          type: 'error'
        });
        return
      }

      this.$router.push({ name: 'ShopInfo', query: { id: item.id } })
    },

    //獲取分類列錶
    GETMenuList() {
      console.log('獲取商品分類')
    },

    //獲取商品列錶
    GETcommodityList(menuId, inputText) {
      console.log("獲取商品列錶")
      console.log(menuId)
      console.log(inputText)
    },
    getRateTotal(id) {
      console.log('獲取商品評分')
      console.log(id)
    }
  }
}
</script>

<style scoped>
.LeftMenuSelected {
  background-color: #fff;
  color: #3E4F7A !important;
  position: relative;
  /* 為偽元素提供定位基準 */
}

.LeftMenuSelected::after {
  content: '';
  position: absolute;
  top: 50%;
  /* 垂直居中 */
  left: 0;
  transform: translateY(-50%);
  /* 精確垂直居中 */
  width: 4px;
  /* 邊框寬度 */
  height: 30px;
  /* 邊框高度 */
  background-color: #3E4F7A;
  /* 邊框顏色 */
}

.project-drawer {

  /* 錶格樣式 */
  .el-table {
    border-radius: 12px;
    overflow: hidden;

    &::before {
      display: none;
    }

    td {
      border-bottom: 1px solid #EBEEF5 !important;
    }
  }

  /* 按鈕懸停效果 */
  .el-button--primary {
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(62, 79, 122, 0.2);
    }
  }

  /* 圖片懸停效果 */
  img {
    transition: all 0.3s;

    &:hover {
      transform: scale(1.02);
    }
  }

  /* WebKit (Chrome, Safari, Edge) 隱藏滾動條 */
  .conter::-webkit-scrollbar {
    display: none;
    /* 針對WebKit瀏覽器隱藏滾動條 */
  }
}

.vipSelected {
  font-weight: 800 !important;
  color: #3E4F7A !important;
  font-size: 15px !important;
}
</style>
